import React, { Component } from "react";

export interface Event {
  originalError: any;
  info: object;
}

export type BasicErrorBoundaryProps = {
  onError?: (event: Event) => void;
};

export class BasicErrorBoundary extends Component<BasicErrorBoundaryProps> {
  public componentDidCatch(error: Error, info: object) {
    const { onError } = this.props;

    if (onError) {
      onError({ originalError: error, info });
    }
  }

  public render() {
    return this.props.children;
  }
}
